// services/create-account.ts
import { api } from "./api";
import {
  ConfirmSignupRequest,
  SignupRequest,
  SignupResponse,
  ConfirmSignupResponse,
  ResendConfirmationRequest,
  ResendConfirmationResponse,
} from "Models/auth";

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    signup: build.mutation<SignupResponse, SignupRequest>({
      query: (params) => ({
        url: "auth/signup",
        method: "POST",
        body: params,
      }),
    }),
    confirmSignup: build.mutation<ConfirmSignupResponse, ConfirmSignupRequest>({
      query: (params) => ({
        url: "auth/confirm-signup",
        method: "POST",
        body: params,
      }),
    }),
    resendConfirmation: build.mutation<ResendConfirmationResponse, ResendConfirmationRequest>({
      query: (params) => ({
        url: "auth/resend-confirmation",
        method: "POST",
        body: params,
      }),
    }),
  }),
});

export const { useSignupMutation, useConfirmSignupMutation, useResendConfirmationMutation } = authApi;
